import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('hooks.useNewAppVersionNotification', {
    title: 'A New Version is Available!',
    description: 'We have noticed you are using an older version{br}of ApprovalMax.',
    reloadText: 'Please reload the page to use the most recent version.',
    reload: 'Reload',
});
